export default function getUsernameByEmailAddress(email: string): string {
  return email.trim().replace('@', '_at_');
}
